import React from "react";
import ReactBubble from "../../assets/REact bubble.png";
import FeatherBubble from "../../assets/feather.png";
import FacebookBubble from "../../assets/facebook bubble.png";
import BitcoinBubble from "../../assets/bitcoin bubble.png";

const Portfolio = () => {
  return (
    <>
      <div
        id="projects"
        className="w-[100vw] h-[100vmin] bg-no-repeat bg-cover bg-top-center text-white bg-skills pt-12 px-[4.4rem]"
      >
        <h2 className="m-4 text-[5vmin] font-bold">Projects</h2>
        <div className="flex justify-center mt-10 mb-10">
          <hr className="w-[80vw]"></hr>
        </div>
        <div className="project-div grid grid-cols-2">
          <div className="project-name flex items-center">
            <h3 className="text-[6vmin] font-bold pl-[8rem]">X-Ray PMS</h3>
          </div>
          <div className="project-category grid grid-rows-2">
            <div className="text-[3vmin] font-medium px-[8rem] flex justify-end">
              <h3>2020</h3>
            </div>
            <div className="text-[3vmin] font-medium px-[8rem] flex justify-end">
              <h3>Design & Development</h3>
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-10 mb-10">
          <hr className="w-[80vw]"></hr>
        </div>
        <div className="project-div grid grid-cols-2">
          <div className="project-name flex items-center">
            <h3 className="text-[6vmin] font-bold pl-[8rem]">Raptor Finance</h3>
          </div>
          <div className="project-category grid grid-rows-2">
            <div className="text-[3vmin] font-medium px-[8rem] flex justify-end">
              <h3>2021</h3>
            </div>
            <div className="text-[3vmin] font-medium px-[8rem] flex justify-end">
              <h3>Research & Design</h3>
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-10 mb-10">
          <hr className="w-[80vw]"></hr>
        </div>
        <div className="project-div grid grid-cols-2">
          <div className="project-name flex items-center">
            <h3 className="text-[6vmin] font-bold pl-[8rem]">ST Management</h3>
          </div>
          <div className="project-category grid grid-rows-2">
            <div className="text-[3vmin] font-medium px-[8rem] flex justify-end">
              <h3>2021</h3>
            </div>
            <div className="text-[3vmin] font-medium px-[8rem] flex justify-end">
              <h3>Design & Development</h3>
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-10 mb-10">
          <hr className="w-[80vw]"></hr>
        </div>
        <div className="flex justify-center mt-16">
          <button className="px-12 py-4 border-4 rounded-full">
            View More Work
          </button>
        </div>
      </div>
    </>
  );
};

export default Portfolio;
